import { render, staticRenderFns } from "./report-jd.vue?vue&type=template&id=08f80471&"
import script from "./report-jd.vue?vue&type=script&lang=js&"
export * from "./report-jd.vue?vue&type=script&lang=js&"
import style0 from "./report-jd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports